import { ContentContainer, FlexColumn } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import { SubClient } from '../../../types/subClient';
import { SubClientForm } from '../SubClientForm';
import { SubClientInfo } from '../SubClientInfo';

type Props = {
  subClient: SubClient;
  onReloadPage: () => void;
};

export function DetailTab({ subClient, onReloadPage }: Readonly<Props>) {
  const [editingMode, setEditingMode] = useState(false);
  const { css } = useStyles();

  return (
    <ContentContainer>
      <FlexColumn
        classNames={css({
          flex: 1,
          width: '50vw',
          maxWidth: '800px',
          boxSizing: 'border-box',
          overflow: 'hidden',
        })}
      >
        {!editingMode && (
          <SubClientInfo
            subClient={subClient}
            onEnabledEditingMode={setEditingMode}
          />
        )}
        {editingMode && (
          <SubClientForm
            onCancel={() => setEditingMode(false)}
            afterSave={() => {
              setEditingMode(false);
              onReloadPage();
            }}
            subClient={subClient}
          />
        )}
      </FlexColumn>
    </ContentContainer>
  );
}
